<template>
  <Header :style="{background: '#fff', boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)'}">
      
    <div class="top_right">
        <div  class="username">
            <img src="../../assets/usrename.png" alt="" class="userimg">
            <span class="spanname">{{userInfo.name}}</span>
        </div>
        <Dropdown trigger="click" class="Tablist" @on-click="changeMenu">
            <div class="oozdiv" >
                <img src="../../assets/setup.png" alt="" class="imgicon">
                <span>设置</span>
            </div>
            <DropdownMenu slot="list" >
                <DropdownItem name='4'  @click="setAdminPwd">修改密码</DropdownItem>
                <DropdownItem name='3' @click="exitLogin">退出登录</DropdownItem>
                
                
            </DropdownMenu>
        </Dropdown>
    </div>
    
     <setAdminModellBox :setAdminModel.sync="adminBox.setAdminModel" :dataRow="adminBox.dataRow"   :fn="adminBox.callbackAdFn"></setAdminModellBox>
     <!--<setModelPic :setAdminModel.sync="picBox.setAdminModel" :dataRow="picBox.dataRow"   :fn="picBox.callbackAdFn"></setModelPic>-->

      <Modal
              :value="showFeedback"
              title="我要反馈"
              :footer-hide="true"
              @on-cancel="cancel"
              :mask-closable="false">

          <Form ref="feedback" :model="feedback" :rules="ruleCustom" :label-width="80">
              <FormItem label="反馈标题" prop="title">
                  <Input type="text" v-model="feedback.title" ></Input>
              </FormItem>
              <FormItem label="反馈图片" prop="images">
                  <!-- <ImgUpload ref="upImg" :action="upload.actionUrl" :num="5" @setThumbUrl="setThumbUrl" @removeThumbUrl='removeThumbUrl'></ImgUpload> -->

              </FormItem>
              <FormItem label="反馈描述" prop="des">
                  <Input type="textarea" :rows="6" v-model="feedback.des"></Input>
              </FormItem>
              <FormItem>
                  <Button :disabled="disabled" type="primary" @click="subData('feedback')">反馈</Button>
              </FormItem>
          </Form>
      </Modal>

      <!-- <div title="将遇到的错误反馈给管理员" class="feedback" @click="showFeedbackModel">
          <Icon type="md-text" class="feedbackIcon" size="24" color="#ffffff"/><br>
          <span class="feedbackText">反馈</span>
      </div> -->
  </Header>
</template>
<script>
import common from '@/common/common.js';
import time from '@/common/time.js';
import setAdminModellBox from './setAdminModel';  //修改密码  (管理员身份)
import ImgUpload from "../common/upload";
    export default {
        name: "Top",
        components: {
            setAdminModellBox,
            ImgUpload
        },
        data(){
            return{
                timerName:'',//定时器名
                loading: true,
                upload:{//图片上传组
                    actionUrl:this.config.urlArray.uploadFeedback,//上传图片接口
                    upload:[],
                },
                disabled:false,
                showFeedback:false,
                feedback:{//添加反馈
                    title:'',
                    images:'',
                    des:'',
                    merchant_id:0
                },
                ruleCustom: {//验证
                    title: [
                        {required: true, message: '反馈标题不能为空', trigger: 'blur' },
                    ],
                    images: [
                        {required: true, message: '反馈图片不能为空', trigger: 'blur' },
                    ],
                    des: [
                        {required: true, message: '反馈描述不能为空', trigger: 'blur' },
                    ],

                },
                stop:{
                    remainTime:'',
                    stopTime:''
                },
                uInfo:{},
                userInfo:{
                    name:""
                },
                detail:{
                    dataRow:{},
                    setDetailModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                adminBox:{//修改密码框组  （管理员身份）
                    dataRow:{},
                    setAdminModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                picBox:{// 设置首页预览组
                    dataRow:{},
                    setAdminModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                }
            }
        },
        created(){
            // this.getData()
            
            this.userInfo.name = JSON.parse(sessionStorage['uInfo']).name//result.data.data.uname
        },
        destroyed(){
            window.clearTimeout(this.timerName);
        },
        methods:{
            showFeedbackModel(){
                this.showFeedback = true
            },
            removeThumbUrl(index){
                this.upload.upload.splice(index, 1);
                this.feedback.images = this.upload.upload.join(',')

            },
            setThumbUrl(url){//获取图片上传后的路径
                this.upload.upload.push(url);
                this.feedback.images = this.upload.upload.join(',')
            },
            cancel() {//对话框关闭
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.feedback.resetFields();//重置表单
                this.showFeedback = false
                this.disabled = false;//恢复提交按钮为激活状态
            },
            toVideoPage() {
                this.$router.push({name: 'videos'});
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        this.axios.post(this.config.urlArray.setFeedback, this.feedback).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.showFeedback = false
                            },()=>{this.disabled = false; })

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });


                    }
                })
            },
            getData(){
                let uInfoName=  JSON.parse(sessionStorage['uInfo'])  //将字符串转为json
                let id = uInfoName.id
                let getData = {
                        params:{
                            merchantId:id,
                            type: 1
                        }
                    }
                this.axios.get(this.config.urlArray.searchOneMerchant,getData).then((result) => {
                    common.ajaxMsg(result.data);
                    //let resData = result.data.data
                    this.uInfo = result.data.data  //将获取的个人信息进行存储
                  
                 
                    this.userInfo.name =  JSON.parse(sessionStorage['uInfo']).name//result.data.data.uname
                   
                }).catch((err) => {
                    common.msg('error','个人信息获取失败',()=>{})
                });
            },
            timeDown() {//倒计时
                //结束时间
                let endDate = new Date(this.stop.stopTime);
                //当前时间
                let nowDate = new Date();
                if(endDate < nowDate){
                    this.stop.remainTime = '已到期，账号不可用'
                }
                //相差的总秒数
                let totalSeconds = parseInt((endDate - nowDate) / 1000);
                //年数
                let years = Math.floor(totalSeconds / (60 * 60 * 24 * 365));
                let modulo = totalSeconds % (60 * 60 * 24 * 365);
                //天数
                let days = Math.floor(modulo / (60 * 60 * 24));
                //取模（余数）
                modulo = modulo % (60 * 60 * 24);
                //小时数
                let hours = Math.floor(modulo / (60 * 60));
                modulo = modulo % (60 * 60);
                //分钟
                let minutes = Math.floor(modulo / 60);
                //秒
                let seconds = modulo % 60;
                //输出到页面
                this.stop.remainTime = years + "年"+ days + "天" + hours + "时" + minutes + "分" + seconds + "秒";
               
                //延迟一秒执行自己
                this.timerName = setTimeout(()=>{
                    this.timeDown()
                }, 1000)
            },
             setDetail (params) {  //查看详情 
                this.detail.setDetailModel = true
                this.detail.dataRow = params
                this.detail.callbackAdFn = () => {//回调处理
                    //重新载入
                    this.detail.setDetailModel = false;
                }
            },
            clearSession(){ //清除缓存
                this.$Modal.confirm({
                    title: '清除缓存',
                    width:400,
                    content: '<p>确认清除缓存？</p>',
                    onOk: () => {
                        let getData = {
                            merchant_id: 0
                        }
                        this.axios.post(this.config.urlArray.clearCache,getData).then((result)=>{
                            common.ajaxMsg(result.data,true,()=>{
                                
                            })
                        }).catch((err)=>{
                            common.msg('error','操作失败')
                        })
                    }
                });
            },
            exitLogin(){  // 退出登录
                this.$Modal.confirm({
                    title: '退出',
                    width:400,
                    content: '<p>确认退出登录？</p>',
                    onOk: () => {
                        let uInfoName=  JSON.parse(sessionStorage['uInfo'])  //将字符串转为json
                       
                        this.axios.post(this.config.urlArray.loginOut,{}).then((result)=>{
                            common.ajaxMsg(result.data,true,()=>{
                                // 清除数据-----删除所有同源的本地存储的localStorage数据
                                localStorage.clear();
                                // 清除数据-----只清空当前会话存储的数据
                                sessionStorage.clear();
                                this.$router.push({ name: 'login', params: {}})
                            })
                        }).catch((err)=>{
                            common.msg('error','退出失败')
                        })
                        
                    }
                });
            },
            changeMenu(name){
                if(name == 1){
                    this.clearSession() //清除缓存
                    // this.setDetail()  //个人信息
                }else if(name == 3){
                    this.exitLogin() //退出登录
                }else if(name == 4){
                    this.setAdminPwd() //管理员修改密码
                }
            },
            setAdminPwd(params){ //管理员修改密码
                this.adminBox.setAdminModel = true
                this.adminBox.dataRow = this.uInfo
                this.adminBox.callbackAdFn = () => {//回调处理
                    //重新载入
                    this.getData()
                    this.adminBox.setAdminModel = false;
                }
            },

        }
    }
</script>
<style>
    .ivu-layout{
        margin-top:65px;
    }
    .ivu-layout-header{
        padding: 0 50px;
        height: 64px;
        position: fixed;
        line-height: 64px;
        z-index: 2;
        border-top: 1px #c5c8ce solid;
        top: 0;
        right: 0;
        width: 100%;
        box-sizing: border-box;
    }
    .h2s{
        float: left;
    }
    .top_right{
        float: right;
        display: flex;
        height: 100%;
        align-items: center;
        text-align: center;
    }
    .imgicon{
        width: 25px;
        height: 25px;
        cursor: pointer;
    }
    .ivu-dropdown-rel{
        display: flex !important;
    }
    .username{
        margin: 0px 15px;
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .ivu-dropdown-item:hover{
        background: #1c9add !important;
        color: #fff;
    }
    .userimg{
        width: 25px;
        height: 25px;
    }
    .spanname{
        font-weight: bold;
        margin: 0px 10px;
    }

    .ivu-form .ivu-form-item-label{
        width:120px !important;
        text-align: center !important;
        text-indent: 1px;
      }
      .ivu-form-item-content{
        margin-left: 120px !important;
      }
    .oozdiv{
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .oozdiv span{
        margin-left:10px;
        font-weight: bold;
    }
    .endtime{
        color: #ff0000
    }
    .feedbackIcon{
        margin-top: 7px;
    }
    .feedback{
        z-index:999;
        text-align:center;
        border-radius:100%;
        color: #ffffff;
        line-height:10px;
        width: 50px;
        height: 50px;
        position: fixed;
        right: 15px;
        bottom: 20px;
        background: #0e6ae7;
        cursor: pointer;
        opacity: 0.7;
    }
    .feedback:hover{
        opacity: 1;
    }
    .feedbackText{
        font-size: 10px;
    }
</style>
